export const CollapsePanelTitle = ({ children }) => {
  return <span className="font-weight-600 font-size-14">{children}</span>;
};
